<div id="particles-js" class="row" style="min-height:100%; overflow-y: auto;">

    <div id="welcome">
        Welcome to my page!
    </div>
</div>